export default function Pricing() {
  const plans = [
    {
      type: '1K',
      price: '35,000円〜',
      features: ['作業人数：2名', '作業時間：2〜3時間', '軽トラック1台分']
    },
    {
      type: '1DK',
      price: '55,000円〜',
      features: ['作業人数：2〜3名', '作業時間：3〜4時間', '2tトラック1台分']
    },
    {
      type: '1LDK',
      price: '80,000円〜',
      features: ['作業人数：3名', '作業時間：4〜5時間', '2tトラック1台分']
    },
    {
      type: '2DK',
      price: '120,000円〜',
      features: ['作業人数：3〜4名', '作業時間：5〜6時間', '2tトラック2台分']
    },
    {
      type: '2LDK',
      price: '150,000円〜',
      features: ['作業人数：4名', '作業時間：6〜7時間', '2tトラック2台分']
    },
    {
      type: '3DK',
      price: '180,000円〜',
      features: ['作業人数：4〜5名', '作業時間：7〜8時間', '4tトラック1台分']
    },
    {
      type: '3LDK',
      price: '220,000円〜',
      features: ['作業人数：5名', '作業時間：8〜9時間', '4tトラック1台分']
    },
    {
      type: '4LDK以上',
      price: 'お見積り',
      features: ['作業人数：応相談', '作業時間：応相談', 'トラック台数：応相談']
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-gradient-to-b from-pink-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">料金体系</h2>
          <p className="text-lg text-gray-600 mb-8">
            明朗会計で安心。お部屋の広さに応じた基本料金です
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <div className="bg-green-600 text-white px-6 py-3 rounded-full font-bold whitespace-nowrap">
              <i className="ri-check-line mr-2"></i>
              現地見積り無料
            </div>
            <div className="bg-green-600 text-white px-6 py-3 rounded-full font-bold whitespace-nowrap">
              <i className="ri-check-line mr-2"></i>
              追加料金なし
            </div>
            <div className="bg-green-600 text-white px-6 py-3 rounded-full font-bold whitespace-nowrap">
              <i className="ri-check-line mr-2"></i>
              各種カード払い可
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 border-2 border-gray-100 hover:border-green-300 transition-colors cursor-pointer"
            >
              <div className="text-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">{plan.type}</h3>
                <div className="text-3xl font-bold text-green-600">{plan.price}</div>
              </div>
              <div className="space-y-2">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-green-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-pink-50 rounded-xl p-8 border border-pink-200">
          <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
            <i className="ri-information-line text-green-600 w-6 h-6 flex items-center justify-center"></i>
            料金に含まれるもの
          </h3>
          <div className="grid md:grid-cols-2 gap-4 text-gray-700">
            <div className="flex items-center gap-2">
              <i className="ri-check-double-line text-green-600 w-5 h-5 flex items-center justify-center"></i>
              <span>作業スタッフ人件費</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-double-line text-green-600 w-5 h-5 flex items-center justify-center"></i>
              <span>車両費・運搬費</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-double-line text-green-600 w-5 h-5 flex items-center justify-center"></i>
              <span>不用品処分費</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-double-line text-green-600 w-5 h-5 flex items-center justify-center"></i>
              <span>簡易清掃</span>
            </div>
          </div>
          <p className="text-sm text-gray-600 mt-4">
            ※お部屋の状況や荷物の量により料金が変動する場合がございます。正確なお見積りは現地調査後にご提示いたします。
          </p>
        </div>
      </div>
    </section>
  );
}
